<template>
  <div id="add-update-coupon-dialog" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading' && coupon == null" key="create-loading" />
      <el-row v-else-if="coupon != null" key="content-loading">
        <div class="modal-body">
          <el-row :gutter="10" class="tab-coupon-contents">
            <el-col :span="8">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input type="text" v-model="coupon.title" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.placeholderTitle')"></el-input>
                <span class="error">{{ $errorMessage("title", couponValidation) }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.prefix") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.prefixMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="coupon.prefix" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.placeholderPrefix')" :disabled="id != null"></el-input>
                <span class="error">{{ $errorMessage("prefix", couponValidation) }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.suffix") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.suffixMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input type="text" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.placeholderSuffix')" v-model="coupon.suffix" :disabled="id != null"></el-input>
                <span class="error">{{ $errorMessage("suffix", couponValidation) }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.note") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.noteMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input type="textarea" :rows="3" v-model="coupon.details" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.placeholderNote')"></el-input>
                <span class="error">{{ $errorMessage("details", couponValidation) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.couponSettings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.couponSettingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="mt-2 mb-3">
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <div class="registerform-input-container">
                            <div class="custom-label">
                              <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.quantity") }}</label>
                              <el-tooltip placement="top">
                                <div slot="content" class="custom-tooltip-content">
                                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.quantityMsg") }}</span>
                                </div>
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </div>
                            <el-input-number v-model="coupon.count" :disabled="id != null"></el-input-number>
                            <span class="error">{{ $errorMessage("count", couponValidation) }}</span>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="registerform-input-container">
                            <div class="custom-label">
                              <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.limit") }}</label>
                              <el-tooltip placement="top">
                                <div slot="content" class="custom-tooltip-content">
                                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.limitMSg") }}</span>
                                </div>
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </div>
                            <el-input-number v-model="coupon.limitPerCoupon" :disabled="id != null"></el-input-number>
                          </div>
                        </el-col>
                      </el-row>

                      <el-row :gutter="10" class="mt-3">
                        <el-col :span="12">
                          <div class="registerform-input-container">
                            <div class="custom-label">
                              <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.discountType") }}</label>
                              <el-tooltip placement="top">
                                <div slot="content" class="custom-tooltip-content">
                                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.discountTypeMsg") }}</span>
                                </div>
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </div>
                            <el-select v-if="getEnums" v-model="coupon.discountType" :disabled="id != null">
                              <el-option v-for="(item, index) in getEnums.find(x => x.title == 'DiscountType').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
                            </el-select>
                          </div>
                        </el-col>

                        <el-col :span="12" v-if="coupon.discountType == 2">
                          <div class="registerform-input-container">
                            <div class="custom-label">
                              <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.discountAmount") }}</label>
                              <el-tooltip placement="top">
                                <div slot="content" class="custom-tooltip-content">
                                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.discountAmountMsg") }}</span>
                                </div>
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </div>
                            <MoneyInput :min="0" :max="99999" :fixed="2" v-model="coupon.discount" clearable :disabled="id != null">
                              <template slot="append">{{ getEnumsDisplay("Currency", currentRegisterForm.paymentInfo.currency) }}</template>
                            </MoneyInput>
                          </div>
                        </el-col>

                        <el-col :span="12" v-if="coupon.discountType == 1">
                          <div class="registerform-input-container">
                            <div class="custom-label">
                              <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.discountPercentage") }}</label>
                              <el-tooltip placement="top">
                                <div slot="content" class="custom-tooltip-content">
                                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.discountPercentageMsg") }}</span>
                                </div>
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </div>
                            <MoneyInput :min="0" :max="100" v-model="coupon.discount" clearable :disabled="id != null">
                              <template slot="append">%</template>
                            </MoneyInput>
                          </div>
                        </el-col>
                      </el-row>
                    </div>

                    <div class="custom-set-container" :class="coupon.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i :class="coupon.isActive ? 'fas fa-ticket-alt' : 'fas fa-ticket-alt'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.status") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.statusMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="coupon.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="coupon.isActivePacketLimitations = !coupon.isActivePacketLimitations">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.packageRestrictions") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.packageRestrictionsMsg") }}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="coupon.isActivePacketLimitations" @change="changePacketLimitations"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="coupon.isActivePacketLimitations">
                    <div class="mt-2 mb-3">
                      <div class="custom-radio-table-title">
                        <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.registrationPackage") }}</div>
                        <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.define") }}</div>
                        <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.required") }}</div>
                      </div>
                      <div class="custom-radio-table-title base " v-for="packet in coupon.packetLimitations" :key="packet.packetId + 'selectPacketd'">
                        <div v-if="currentRegisterForm.packets.find(x => x.id == packet.packetId) != null">
                          {{ currentRegisterForm.packets.find(x => x.id == packet.packetId).title }}
                        </div>
                        <div>
                          <el-radio v-model="packet.type" :label="0">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.show") }}</el-radio>
                        </div>
                        <div>
                          <el-radio v-model="packet.type" :label="1">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.required") }}</el-radio>
                        </div>
                        <div>

                        <el-tooltip v-if="packet.type != null" class="" effect="dark" :content="$t('event.table.delete')" placement="top">
                          <el-popconfirm @confirm="packet.type = null" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                            <el-button slot="reference" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
                          </el-popconfirm>
                        </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="coupon.enableNotifications = !coupon.enableNotifications">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.reminder") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.reminderMsg") }}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="coupon.enableNotifications"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="coupon.enableNotifications">
                    <el-row :gutter="10" class="mt-3">
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.nameSurname") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.nameSurnameMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-input type="text" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.placeholderNameSurname')" v-model="coupon.fullName"></el-input>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.email") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.emailMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-input type="text" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.placeholderMail')" v-model="coupon.email"></el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && coupon != null">
      <div class="left-buttons">
        <el-button @click="closeMe">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.close") }}</el-button>
        <template v-if="id != null">
          <el-popconfirm @confirm="deleteCoupon()" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveCoupon'" :disabled="loading == 'saveCoupon'" @click="saveCoupon()">{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.addRegistrationCoupon.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { quillEditor } from "vue-quill-editor";
import MoneyInput from "./Inputs/MoneyInput.vue";
export default {
  props: ["id", "formId"],
  components: {
    quillEditor,
    draggable,
    MoneyInput
  },
  data() {
    return {
      settingsDock: false,
      coupon: null,
      loading: false,
      drag: false,
      currDate: new Date().getTime(),
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      }
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    couponValidation() {
      return this.$store.getters.getCouponAddValidation;
    },
    couponForm() {
      return this.$store.getters.getRegistrationCouponForm;
    },
    currentRegisterForm() {
      return this.$store.getters.getCurrentRegisterForm;
    },
    tagList() {
      return this.$store.getters.getTagsList;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  created() {
    this.checkedId();
  },
  methods: {
    async deleteCoupon() {
      this.loading = "deleteCoupon";
      var res = await this.$store.dispatch("registrationCouponDelete", this.id);
      console.log("deleteCoupon", res);

      if (!res.data.alert.hasError) {
        this.$emit("refresh");
        this.closeMe();
      }
      this.loading = false;
    },
    enableCoupon(e) {
      this.coupon.enableNotifications = !this.coupon.enableNotifications;
    },
    changePacketLimitations() {
      if (!this.coupon.isActivePacketLimitations) {
        this.coupon.packetLimitations = [];
        if (this.currentRegisterForm.packets.length > 0) {
          this.currentRegisterForm.packets.map(x => {
            var fIndex = this.coupon.packetLimitations.findIndex(y => y.packetId == x.id);
            if (fIndex == -1) {
              var payload = {
                packetId: x.id,
                title: x.title,
                stock: x.stock,
                type: null
              };
              this.coupon.packetLimitations.push(payload);
            }
          });
        }
      }
    },
    async saveCoupon() {
      this.loading = "saveCoupon";
      var res = await this.$store.dispatch("addOrUpdateRegisterCoupon", this.coupon);
      if (!res.data.alert.hasError) {
        this.$emit("refresh");
        this.closeMe();
      }
      this.loading = false;
    },

    closeMe() {
      this.$emit("closeDialog");
    },
    addDayRestrictions() {
      this.packet.dayRestrictions.push({
        id: null,
        title: "Yeni Gün",
        date: null,
        isActive: true
      });
    },
    addPricingOption() {
      this.packet.priceOptions.push({
        id: null,
        title: this.$t('generic.newOption'),
        startDate: null,
        endDate: null,
        price: 0,
        isActive: true
      });
    },
    onEditorReady(editor) {
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    async checkedId() {
      this.loading = "updateScreenLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.$store.commit("setCouponValidationOne", []);
        if (this.id) {
          var res = await this.$store.dispatch("getCouponGroup", { id: this.id, skip: 0, take: 20 });
          if (!res.data.alert.hasError) {
            this.coupon = res.data.data.item;
          }
        } else {
          this.coupon = JSON.parse(JSON.stringify(this.couponForm));
          this.coupon.registrationFormId = this.formId;
        }
        //TODO PacketLimitations içindeki paketler currentRegisterForm 'da yoksa temizlienicek
        if (this.currentRegisterForm.packets.length > 0) {
          this.currentRegisterForm.packets.map(x => {
            var fIndex = this.coupon.packetLimitations.findIndex(y => y.packetId == x.id);
            if (fIndex == -1) {
              var payload = {
                packetId: x.id,
                title: x.title,
                stock: x.stock,
                type: null
              };
              this.coupon.packetLimitations.push(payload);
            }
          });
        }
        this.loading = false;
      }, 500);
    }
  },
  watch: {
    id() {
      this.checkedId();
    }
  }
};
</script>

<style lang="less">
.tab-coupon-contents {
  & > .el-col {
    margin-bottom: 1rem;
  }
  .el-input-number {
    width: 100%;
  }
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      height: 120px;
      .el-icon-upload {
        font-size: 30px;
        margin: 0;
      }
    }
  }
  .packet-head {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr 1fr 1fr;
  }
}

.add-update-coupon-dialog-container {
  .bottom {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
}
.coupon-type-list-title {
  display: grid;
  grid-template-columns: 3fr 3fr 1fr 1fr;
}

.add-pricing-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/addOrUpdateRegistrationCoupon.vue